import { render } from "./m-loby-item.vue?vue&type=template&id=81f6cbb6&scoped=true&ts=true"
import script from "./m-loby-item.vue?vue&type=script&lang=ts"
export * from "./m-loby-item.vue?vue&type=script&lang=ts"

import "./m-loby-item.vue?vue&type=style&index=0&id=81f6cbb6&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81f6cbb6"]])

export default __exports__